import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TicketsComponent} from './tickets.component';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatTableModule} from "@angular/material/table";
import {MatSortModule} from "@angular/material/sort";
import {MatPaginatorModule} from "@angular/material/paginator";
import {LogPipeModule} from "@app/pipes/log/log-pipe.module";
import {TicketStatusModule} from "@app/pipes/ticket-status/ticket-status.module";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {DisplayDateModule} from "@app/pipes/display-date/display-date.module";
import {MatTabsModule} from "@angular/material/tabs";
import {MatSelectModule} from "@angular/material/select";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatListModule} from "@angular/material/list";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NewTicketModule} from "@app/pages/tickets/new-ticket/new-ticket.module";
import {FilterPipeModule} from "@app/pipes/filter/filter-pipe.module";
import {MatRadioModule} from "@angular/material/radio";
import {MatNativeDateModule} from "@angular/material/core";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {RouterModule} from "@angular/router";
import {UsernameToNameModule} from "@app/pipes/username-to-name/username-to-name.module";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatIconModule} from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";


@NgModule({
    declarations: [TicketsComponent],
  imports: [
    CommonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    LogPipeModule,
    TicketStatusModule,
    MatCardModule,
    MatButtonModule,
    DisplayDateModule,
    MatTabsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatListModule,
    FormsModule,
    NewTicketModule,
    FilterPipeModule,
    MatRadioModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    RouterModule,
    UsernameToNameModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatIconModule,
    MatTooltipModule
  ]
})
export class TicketsModule {
}
